// extracted by mini-css-extract-plugin
export default {"label":"ci_label__SycRl","c":"ci_c__GIb0M","e":"ci_e__OZpwG","icon":"ci_icon__e7mv8","tx":"ci_tx__ihHtb"};